import { render } from "./new-assessment.vue?vue&type=template&id=eb4e8ab4"
import script from "./new-assessment.vue?vue&type=script&lang=js"
export * from "./new-assessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__